module.exports = __webpack_public_path__ + "static/media/accounting.9f0e1ba8.jpg";